import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 3 }
const _hoisted_2 = { class: "rounded-xl border-dashed border-2 border-blue-500" }
const _hoisted_3 = {
  class: "text-center",
  style: { marginTop: '-0.75rem' }
}
const _hoisted_4 = { class: "bg-white text-blue-500 font-bold px-2 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentCustomizingPurchaseCountInput = _resolveComponent("ContentCustomizingPurchaseCountInput")!
  const _component_ContentCustomizingPurchaseCountDeclare = _resolveComponent("ContentCustomizingPurchaseCountDeclare")!
  const _component_ContentCustomizingUploadedText = _resolveComponent("ContentCustomizingUploadedText")!
  const _component_Content = _resolveComponent("Content")!

  return (_ctx.keyName === 'purchase_count_input')
    ? (_openBlock(), _createBlock(_component_ContentCustomizingPurchaseCountInput, { key: 0 }))
    : (_ctx.keyName === 'purchase_count_declare')
      ? (_openBlock(), _createBlock(_component_ContentCustomizingPurchaseCountDeclare, { key: 1 }))
      : (_ctx.keyName === 'uploaded_text')
        ? (_openBlock(), _createBlock(_component_ContentCustomizingUploadedText, {
            key: 2,
            contents: _ctx.contents
          }, null, 8, ["contents"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, " このコンテンツは未実装（キー名: " + _toDisplayString(_ctx.keyName || '（未設定）') + "） ", 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
                return (_openBlock(), _createBlock(_component_Content, {
                  key: index,
                  content: content
                }, null, 8, ["content"]))
              }), 128))
            ])
          ]))
}